import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate, Navigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Package, Calendar, Settings, LogOut, Menu, X, ArrowDownUp, FileSpreadsheet, FileText, Truck, ScrollText } from 'lucide-react';
import { t } from '../utils/translation';
import '../styles/layout.css';
import logo from '../assets/logo_clt.gif';

export default function Layout() {
    const { currentUser, logout, loading, userRole } = useAuth();
    const navigate = useNavigate();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);


    if (loading) return <div className="flex h-screen items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div></div>;
    if (!currentUser) return <Navigate to="/login" />;

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const navItems = [
        { to: '/dashboard', label: t('NAV.DASHBOARD'), icon: LayoutDashboard },
        { to: '/products', label: t('NAV.PRODUCTS'), icon: Package },
        { to: '/inventory', label: t('NAV.INVENTORY'), icon: ArrowDownUp },
        { to: '/events', label: t('NAV.EVENTS'), icon: Calendar },
        { to: '/recipes', label: t('RECIPES.TITLE'), icon: ScrollText },
        { to: '/suppliers', label: t('NAV.SUPPLIERS'), icon: Truck },
        { to: '/imports', label: t('NAV.SALES_IMPORT'), icon: FileSpreadsheet },
        { to: '/reports', label: t('NAV.REPORTS'), icon: FileText },
    ];

    if (['admin', 'super_admin'].includes(userRole)) {
        navItems.push({ to: '/settings', label: t('NAV.SETTINGS'), icon: Settings });
    }

    const NavContent = () => (
        <>
            <div className="sidebar-header">
                <Link to="/" className="block">
                    <img src={logo} alt="Inventaire U" className="app-logo" />
                </Link>
                <div className="role-badge mt-2">{userRole} view</div>
            </div>

            <nav className="sidebar-nav">
                {navItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        onClick={() => setIsMobileMenuOpen(false)}
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                    >
                        <item.icon size={20} className="nav-icon" />
                        {item.label}
                    </NavLink>
                ))}
            </nav>

            <div className="sidebar-footer">
                <button onClick={handleLogout} className="logout-btn">
                    <LogOut size={20} className="nav-icon" />
                    {t('NAV.SIGNOUT')}
                </button>
            </div>
        </>
    );

    return (
        <div className="app-layout">
            {/* Desktop Sidebar */}
            <aside className="sidebar desktop-sidebar">
                <NavContent />
            </aside>

            {/* Main Content Wrapper */}
            <div className="main-wrapper">

                {/* Mobile Header */}
                <header className="mobile-header">
                    <Link to="/">
                        <img src={logo} alt="Inventaire U" className="app-logo" style={{ height: '48px' }} />
                    </Link>
                    <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="menu-btn">
                        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </header>

                {/* Mobile Menu Overlay */}
                {isMobileMenuOpen && (
                    <div className="mobile-menu-overlay" onClick={() => setIsMobileMenuOpen(false)}>
                        <div className="mobile-menu-sidebar" onClick={e => e.stopPropagation()}>
                            <NavContent />
                        </div>
                    </div>
                )}

                {/* Main Content Area */}
                <main className="page-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
